import protectedAxios from '../auth/axios.js';

export const comboMixin = {
  methods: {
    async loadCombos(combos) {
      let promises = [];

      combos.forEach(cm => {
        promises.push(this.loadCombo(cm));
      });

      return Promise.all(promises);
    },

    async loadCombo(combo) {
      return protectedAxios
        .get(`cis/${combo.key}`, {
          params: combo.params,
        })
        .then(res => {
          let result = {
            key: combo.key,
            data: res.data,
          };
          return result;
        });
    },
  },
};
